var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('keyword-list-input', {
    attrs: {
      "label": _vm.label,
      "options": _vm.indexesOptions
    },
    model: {
      value: (_vm.selectedIndexes),
      callback: function($$v) {
        _vm.selectedIndexes = $$v
      },
      expression: "selectedIndexes"
    }
  }), _vm._v(" "), _c('confirmation-button', {
    attrs: {
      "text": _vm.reIndexLabel
    },
    on: {
      "confirm": function($event) {
        _vm.reindex(_vm.selectedIndexes)
      }
    }
  }), _vm._v(" "), _c('confirmation-button', {
    attrs: {
      "text": _vm.forceFailLabel
    },
    on: {
      "confirm": function($event) {
        _vm.force_fail()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lastOperationResult === 'pending'),
      expression: "lastOperationResult === 'pending'"
    }]
  }, [_vm._v("Loading...")]), _vm._v(" " + _vm._s(_vm.lastOperationResult) + "\n\n")], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e8b40ef","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Maintenance/MaintenanceIndexView.vue
// module id = 1853
// module chunks = 0